export const GenogramSexualCommunicationEnum = {
	SEX_POSITIVE: "sex_positive",
	SEX_NEGATIVE: "sex_negative",
	SEX_NEUTRAL: "sex_neutral",
}

